function ChartLoader() {
    return (
        <div style={{ textAlign: "center" }}>
            <h5>Loading chart...</h5>
        </div>
    );
}

export default ChartLoader;
